import React from 'react'
import { useForm, Form, Field, useFieldArray, isEmpty } from '../../form'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Snackbar from '@material-ui/core/Snackbar'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { useHistory } from 'react-router-dom'
import { Translation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'
import { expenseValidate } from '../../containers/validate'
import ExpenseInputRow from './newExpenseInputRow.component'
import AddToInvoice from './addToInvoice.component'
import Consent from './consent.component'

class NewExpenseComponent extends React.Component {
  componentDidMount() {
    this.props.getUserCompanyUpdateInfo()
  }
  render() {
    return <NewExpense {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  table: {
    minWidth: 500
  },
  tablecell: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e'
  },
  tablecell1: {
    minWidth: 40,
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    paddingRight: '0px !important',
    paddingLeft: '12px !important'
  },
  button: {
    margin: theme.spacing(1),
    marginRight: 0
  },
  buttonFile: {
    marginTop: theme.spacing(3)
  },
  select: {
    lineHeight: '1.5',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    border: '1px solid gray'
  },
  selectInvoice: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderBottom: '1px solid gray',
    maxWidth: 300,
    fontSize: '14px'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontWeight: '500'
  },
  resize: {
    fontSize: '14px'
  },
  progress: {
    flexGrow: 1
  },
  radioButton: {
    fontSize: '15px',
    marginTop: '0px',
    marginLeft: '19px',
    marginRight: '-19px',
    color: '#808080',
    paddingTop: 0,
    paddingBottom: 0
  },
  checkbox: {
    fontSize: '15px',
    color: '#808080'
  },
  unselectButton: {
    float: 'right',
    [theme.breakpoints.down('sm')]: {
      margin: '16px auto',
      float: 'left',
      width: '100%'
    }
  }
})

const rowDefaultValues = {
  description: '',
  sum: '',
  vat: 25.5,
  sumWithoutVat: 0,
  cost_type: ''
}

const date = new Date()
const defaultValues = {
  place_of_purchase: '',
  date_of_purchase: date,
  decisionSelect: '',
  consent: false,
  inputFile: '',
  expenseInputRow: [rowDefaultValues],
  receipt_picture: ''
}

const NewExpense = ({
  // addExpenseRow,
  // showInvoices,
  // submitFailed,
  saveExpense,
  showSpinner,
  showExpenseItemLoader,
  showSnackbar,
  closeSnackbar,
  showFailSnackbar,
  errorStatus,
  isEdit,
  saveExpenseUpdate,
  cancelExpenseUpdate,
  classes,
  // expense_row_exist,
  // consent
  //changeExpensePurchaseDate
  showTravelCostsInfo,
  isReadOnly
}) => {
  const history = useHistory()
  const [submitFailed, setSubmitFailed] = React.useState(false)
  const [attemptingSubmit, setAttemptingSubmit] = React.useState(false)

  const form = useForm({
    name: 'expense',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: expenseValidate,
    mode: 'onChange',
    resetOnSubmit: false
  })

  const {
    control,
    setValue,
    clearErrors,
    formState: { errors }
  } = form

  const rowState = useFieldArray({
    name: 'expenseInputRow',
    control
  })

  const { fields } = rowState

  function addRow() {
    rowState.append(rowDefaultValues)
  }

  function removeRow(index) {
    rowState.remove(index)
  }

  function onSubmit(values) {
    if (isEdit) saveExpenseUpdate(values)
    else {
      saveExpense(values)
    }
  }

  React.useEffect(() => {
    if (attemptingSubmit && !isEmpty(errors)) {
      setSubmitFailed(true)
      setAttemptingSubmit(false)
    }
  }, [attemptingSubmit, setSubmitFailed, errors])

  const validationTextStyle = { marginTop: '0px', height: '0px' }

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container-fluid">
            <div className="row">
              <div
                className="dashboard-content-header"
                style={{ marginBottom: '-12px' }}
              >
                {showTravelCostsInfo ? (
                  <h1>{t('newExpenc.h2')}</h1> // Cost receipt info
                ) : isEdit ? (
                  <h1>{t('newExpenc.h1')}</h1> // Edit expense receipt
                ) : (
                  <h1>{t('newExpenc.h1a')}</h1> // Create a new expense
                )}
              </div>
            </div>

            <Form {...form}>
              <div className="row">
                <div className="dashboard-content-header">
                  <div
                    className="col-xs-12 col-sm-12"
                    style={{
                      width: '100%',
                      padding: 0
                    }}
                  >
                    <div
                      className="panel panel-default"
                      style={{
                        margin: 0,
                        padding: 0
                      }}
                    >
                      <div
                        className="panel-heading"
                        style={{ textAlign: 'left', paddingLeft: '26px' }}
                      >
                        <h3 className="panel-title">{t('newExpenc.h3')}</h3>
                      </div>
                      <div
                        className="panel-body"
                        style={{
                          marginLeft: mobileView ? '30px' : '0',
                          marginRight: mobileView ? '30px' : '0',
                          display: mobileView ? 'block' : 'flex',
                          gap: mobileView ? '0' : '16px',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          paddingLeft: mobileView ? '0' : '10px',
                          paddingRight: mobileView ? '0' : undefined
                        }}
                      >
                        <div
                          style={{
                            flex: mobileView ? '1 1 100%' : '0 0 346px',
                            marginTop: mobileView ? '0px' : '-24px'
                          }}
                        >
                          <Field
                            name="place_of_purchase"
                            inputType="textfield"
                            label={t('newExpenc.label2') + '*'}
                            control={control}
                            disabled={isReadOnly}
                            helperTextStyle={validationTextStyle}
                            className={classNames(
                              classes.textField,
                              classes.resize
                            )}
                            autoFocus
                          />
                        </div>
                        <div
                          style={{
                            marginTop: mobileView ? '0px' : '-24px',
                            maxWidth: mobileView ? '100%' : '150px',
                            width: mobileView ? '100%' : undefined,
                            marginLeft: mobileView ? '0' : undefined
                          }}
                        >
                          <Field
                            name="date_of_purchase"
                            inputType="datepicker"
                            label={t('newExpenc.label3') + '*'}
                            control={control}
                            disabled={isReadOnly}
                            className={classNames(
                              classes.textField,
                              classes.resize
                            )}
                            //onChangeCallback={changeExpensePurchaseDate}
                            showCalendarIcon
                          />
                        </div>
                        <div
                          className="dashboard-expense"
                          style={{
                            marginTop: mobileView ? '0px' : '-24px',
                            maxWidth: mobileView ? '100%' : '250px',
                            width: mobileView ? '100%' : undefined,
                            marginLeft: mobileView ? '0' : undefined,
                            paddingBottom: '0px'
                          }}
                        >
                          {isEdit ? (
                            <Field
                              name="receipt_picture"
                              placeholder={t('newExpenc.holder')}
                              label={t('newExpenc.label10')}
                              labelStyle={{ whiteSpace: 'nowrap' }}
                              control={control}
                              disabled={true}
                              helperTextStyle={validationTextStyle}
                              inputType="textfield"
                              className={classNames(
                                classes.textField,
                                classes.resize
                              )}
                            />
                          ) : (
                            <Field
                              name="receipt_picture"
                              placeholder={t('newExpenc.holder2')}
                              label={t('newExpenc.label10')}
                              labelStyle={{ whiteSpace: 'nowrap' }}
                              control={control}
                              disabled={true}
                              helperTextStyle={validationTextStyle}
                              inputType="textfield"
                              className={classNames(
                                classes.textField,
                                classes.resize
                              )}
                            />
                          )}
                        </div>

                        <div
                          className="pull-right"
                          style={{
                            marginTop: mobileView ? '16px' : '0'
                          }}
                        >
                          <Button
                            variant="contained"
                            disabled={isReadOnly}
                            className={classes.buttonFile}
                            component="label"
                            htmlFor="input-tax"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            {t('newExpenc.label4')}
                          </Button>
                        </div>
                        <div
                          className="dashboard-tax-input"
                          style={{ display: 'none' }}
                        >
                          <Field
                            name="inputFile"
                            inputType="file"
                            id="input-tax"
                            control={control}
                            onChange={(e) => {
                              setValue(
                                'receipt_picture',
                                e.target.value.split('\\').slice(-1).pop()
                              )
                              clearErrors('receipt_picture')
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Costs */}
                    <div
                      className="panel-heading"
                      style={{
                        margin: mobileView ? null : '0px 15px 0px 15px'
                      }}
                    >
                      {mobileView
                        ? expenseTableMobile(
                            classes,
                            fields,
                            addRow,
                            removeRow,
                            control,
                            setValue,
                            isReadOnly
                          )
                        : expenseTable(
                            classes,
                            fields,
                            addRow,
                            removeRow,
                            control,
                            setValue,
                            isReadOnly
                          )}
                    </div>
                  </div>
                  <div
                    className="col-xs-12 col-sm-12"
                    style={{ margin: 0, padding: 0 }}
                  >
                    <div className="panel panel-default">
                      {/*         <div className="panel-heading">
                        <h3 className="panel-title">
                          {t('decisionDialog.dialogTitle')}
                        </h3>
                      </div> */}
                      <AddToInvoice
                        classes={classes}
                        type="newExpense"
                        control={control}
                        disabled={isReadOnly}
                      />
                    </div>
                    <Consent
                      classes={classes}
                      control={control}
                      invoiceItemType="expense"
                      disabled={isReadOnly}
                    />
                  </div>
                </div>
              </div>

              <div
                className="row"
                style={{ marginRight: '28px', marginBottom: '10px' }}
              >
                {isEdit ? (
                  !isReadOnly && (
                    <ul className="nav nav-pills pull-right">
                      <li>
                        <Button
                          variant="outlined"
                          className={classes.button}
                          onClick={() => {
                            cancelExpenseUpdate()
                            history.push('/dashboard/fee')
                          }}
                        >
                          {t('newExpenc.label5')}
                        </Button>
                      </li>
                      <li>
                        <Button
                          variant="contained"
                          className={classes.button}
                          type="submit"
                          onClick={() => setAttemptingSubmit(true)}
                        >
                          {t('newExpenc.label6')}
                        </Button>
                      </li>
                    </ul>
                  )
                ) : (
                  <div
                    className="pull-right"
                    style={{
                      transform: 'translateX(8px)',
                      paddingRight: mobileView ? undefined : '12px'
                    }}
                  >
                    <Button
                      variant="contained"
                      className={classes.button}
                      type="submit"
                      onClick={() => setAttemptingSubmit(true)}
                    >
                      {t('newExpenc.label7')}
                    </Button>
                  </div>
                )}
              </div>
            </Form>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closeSnackbar()
                history.push('/dashboard/fee')
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeSnackbar()
                  history.push('/dashboard/fee')
                }}
                variant="success"
                message={t('newExpenc.msg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={submitFailed && !isEmpty(errors)}
              autoHideDuration={2000}
            >
              <MySnackbarContentWrapper
                noCloseIcon={true}
                variant="error"
                message={t('newExpenc.msg2')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showFailSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closeSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeSnackbar()
                }}
                variant="error"
                message={
                  errorStatus === 400
                    ? t('newExpenc.failMsg')
                    : t('newExpenc.msg3')
                }
              />
            </Snackbar>
            <Dialog
              open={showSpinner}
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ fontSize: '15px', margin: '20px' }}
                >
                  {t('newExpenc.title')}
                </DialogContentText>
              </DialogContent>
              <div className={classes.progress}>
                <LinearProgress />
              </div>
            </Dialog>
            <Dialog
              //open={store.getState().loader.showExpenseItemLoader}
              open={showExpenseItemLoader}
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ fontSize: '15px', margin: '20px' }}
                >
                  {t('login.dialog')}
                </DialogContentText>
              </DialogContent>
              <div className={classes.progress}>
                <LinearProgress />
              </div>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

const expenseTable = (
  classes,
  fields,
  addRow,
  removeRow,
  control,
  setValue,
  isReadOnly
) => (
  <Translation>
    {(t) => {
      return (
        <div className="row">
          <div className="dashboard-content-header">
            <div className="panel panel-default" style={{ marginTop: '-18px' }}>
              <div className={classes.root} style={{ overflowX: 'auto' }}>
                <Table
                  className={classes.table}
                  style={{ tableLayout: 'fixed', width: 'auto' }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className={classes.tablecell1}
                        style={{ width: '235px' }}
                      >
                        {t('newExpenc.costs')}*
                      </TableCell>
                      <TableCell
                        className={classes.tablecell1}
                        style={{ width: '344px' }}
                      >
                        {t('newExpenc.table')}*
                      </TableCell>
                      <TableCell
                        className={classes.tablecell1}
                        style={{ width: '139px' }}
                      >
                        {t('newExpenc.table2')}*
                      </TableCell>
                      <TableCell
                        className={classes.tablecell1}
                        style={{ width: '81px' }}
                      >
                        {t('newExpenc.table3')}
                      </TableCell>
                      <TableCell
                        className={classes.tablecell1}
                        style={{ width: '139px' }}
                      >
                        {t('newExpenc.sumWithoutVat')}
                      </TableCell>
                      <TableCell
                        className={classes.tablecell1}
                        style={{ width: '50px' }}
                      >
                        {/* Empty for actions */}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getExpenseRows(
                      fields,
                      removeRow,
                      control,
                      setValue,
                      isReadOnly
                    )}
                  </TableBody>
                </Table>
              </div>
              <div
                className="dashboard-invoice-add pull-right"
                style={{
                  margin: 0,
                  padding: 0
                }}
              >
                <Button
                  variant="outlined"
                  className={classes.button}
                  onClick={addRow}
                  disabled={isReadOnly}
                  style={{ marginRight: '32px' }}
                >
                  {t('newExpenc.label8')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )
    }}
  </Translation>
)
const expenseTableMobile = (
  classes,
  fields,
  addRow,
  removeRow,
  control,
  setValue,
  isReadOnly
) => (
  <Translation>
    {(t) => {
      return (
        <div className="row">
          <div className="dashboard-content-header">
            <div className="col-xs-12 col-sm-12 col-lg-12">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">{t('newExpenc.h3a')}</h3>
                </div>
                <div className={classes.root}>
                  {getExpenseRows(
                    fields,
                    removeRow,
                    control,
                    setValue,
                    isReadOnly
                  )}
                  <div
                    className={
                      !mobileView
                        ? 'dashboard-invoice-add pull-right'
                        : 'pull-right'
                    }
                  >
                    <Button
                      variant="outlined"
                      className={classes.button}
                      onClick={addRow}
                      disabled={isReadOnly}
                      style={mobileView ? { marginRight: 15 } : null}
                    >
                      {t('newExpenc.label8')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }}
  </Translation>
)

export const getExpenseRows = (fields, remove, control, setValue, isReadOnly) =>
  fields.map((field, index) => (
    <ExpenseInputRow
      index={index}
      key={field.id}
      autoFocusIndex={`${index}`}
      cost_type={`expenseInputRow.${index}.cost_type`}
      description={`expenseInputRow.${index}.description`}
      sum={`expenseInputRow.${index}.sum`}
      vat={`expenseInputRow.${index}.vat`}
      sumWithoutVat={`expenseInputRow.${index}.sumWithoutVat`}
      remove={remove}
      control={control}
      isReadOnly={isReadOnly}
      setValue={setValue}
    />
  ))

NewExpenseComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(NewExpenseComponent)
